import { LitElement, html, css } from 'lit'

/**
 * Componente de loading global da aplicação
 * Exibe uma tela de carregamento com animação
 */
class LoadingShade extends LitElement {
  static properties = {
    visible: { type: Boolean },
    message: { type: String }
  }

  static styles = css`
    :host {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s ease, visibility 0.3s ease;
    }

    :host([visible]) {
      opacity: 1;
      visibility: visible;
    }

    .loading-content {
      background: var(--bg-surface, #151C30);
      padding: 2rem;
      border-radius: var(--radius-input, 12px);
      text-align: center;
      box-shadow: var(--shadow-card, 0 10px 40px rgba(0,0,0,0.35));
    }

    .spinner {
      width: 40px;
      height: 40px;
      border: 4px solid var(--border, #26304A);
      border-top: 4px solid var(--primary, #6120D8);
      border-radius: 50%;
      animation: spin 1s linear infinite;
      margin: 0 auto 1rem;
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    .message {
      color: var(--text-primary, #F4F7FF);
      font-size: 0.9rem;
    }
  `

  constructor() {
    super()
    this.visible = false
    this.message = 'Carregando...'
  }

  show(message = 'Carregando...') {
    this.message = message
    this.visible = true
  }

  hide() {
    this.visible = false
  }

  render() {
    return html`
      <div class="loading-content" data-cy="loading-shade-content">
        <div class="spinner" data-cy="loading-shade-spinner"></div>
        <div class="message" data-cy="loading-shade-message">${this.message}</div>
      </div>
    `
  }
}

customElements.define('loading-shade', LoadingShade)